import { createRef, useState } from 'react';
import { ProgramNameMapping } from '../../types/sharedTypeImpl.ts';
import { trpc } from '../../utils/trpc/trpc.ts';
import { ModalSubmitDialog } from '../modalSubmitDialog.tsx';
import { OperatorSelect } from '../operatorSelect.tsx';
import { attemptAddProgramName } from '../protocol-form/attemptAddProgramName.ts';


interface Props {
    partNumber: string;
    protocolId: string;
    mappings: ProgramNameMapping[];
    onSuccess: () => void;
    onClose: () => void;
}

export function AddProgramDialog({
    partNumber,
    protocolId,
    mappings,
    onSuccess,
    onClose,
}: Props) {

    const formRef = createRef<HTMLFormElement>();
    const [programName, setProgramName] = useState('');
    const [user, setUser] = useState('');
    const programNames = mappings.map(m => m.program);

    const addProgramToProtocol = trpc.protocols.addProgram.useMutation();


    async function handleSubmit() {
        const { isValid } = attemptAddProgramName(programNames, programName);
        if (!isValid) {
            return;
        }

        try {
            await addProgramToProtocol.mutateAsync({
                protocolId,
                program: programName,
                user,
            });
            onSuccess();
            onClose();
        } catch (error) {
            alert('Failed to add program.');
            return;
        }
    }

    return (
        <ModalSubmitDialog
            frameStyle={{ width: '360px' }}
            isOpen={true}
            isSubmitting={addProgramToProtocol.isPending}
            onCancel={onClose}
            onSubmit={handleSubmit}
        >
            <form ref={formRef} >
                <div>Add program for part {partNumber}</div>
                <div>Current programs: {programNames.join(', ')}</div>

                <div className='dialog-form__field--with-margins' >
                    <div>Position number column (A-Z)</div>
                    <input
                        className='dialog-form__input'
                        type='text'
                        required
                        value={programName}
                        onChange={e => setProgramName(e.target.value)}
                    />
                </div>

                <div className='dialog-form__field--with-margins'>
                    <div>User</div>
                    <OperatorSelect
                        style={{ width: '100%' }}
                        operatorInitials={user}
                        onChange={(value) => setUser(value)}
                        required
                    />
                </div>
            </form>
        </ModalSubmitDialog>
    );
}
